// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GAsaC7eW {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.55);
  -webkit-backdrop-filter: blur(4px);
          backdrop-filter: blur(4px);
  z-index: 2002;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
          align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
          justify-content: center;
  padding: 2.5rem 1rem;
}
.suc4ymdU {
  position: relative;
  width: 100%;
  max-width: 30rem;
  box-sizing: border-box;
  background: #fffdf2;
  border-radius: 2rem;
  box-shadow: 0 0.625rem 1.75rem rgba(61, 48, 42, 0.22);
  -webkit-animation: Uu20LBJN 0.3s ease;
          animation: Uu20LBJN 0.3s ease;
  overflow: visible;
  font-family: 'Source Han Sans SC', 'PingFang SC', 'Microsoft YaHei', sans-serif;
}
@media (max-width: 767px) {
  .suc4ymdU {
    max-width: min(30rem, 92vw);
    border-radius: 1.75rem;
  }
}
.zOPoxSzF {
  padding: 2.75rem 1.75rem 2rem 1.75rem;
}
@media (max-width: 767px) {
  .zOPoxSzF {
    padding: 2.125rem 1.75rem 1.125rem;
  }
}
.dciSjzjV {
  padding: 2.75rem 2rem 2rem;
  text-align: center;
}
@media (max-width: 767px) {
  .dciSjzjV {
    padding: 2.5rem 1.75rem 1.75rem;
  }
}
@-webkit-keyframes Uu20LBJN {
  from {
    opacity: 0;
    -webkit-transform: translateY(1.25rem);
            transform: translateY(1.25rem);
  }
  to {
    opacity: 1;
    -webkit-transform: translateY(0);
            transform: translateY(0);
  }
}
@keyframes Uu20LBJN {
  from {
    opacity: 0;
    -webkit-transform: translateY(1.25rem);
            transform: translateY(1.25rem);
  }
  to {
    opacity: 1;
    -webkit-transform: translateY(0);
            transform: translateY(0);
  }
}
.VFpHxQM9 {
  background: none;
  margin: 0;
  outline: none;
  font-family: inherit;
  position: absolute;
  top: -0.875rem;
  right: -1.5rem;
  width: 4rem;
  height: 4rem;
  padding: 0;
  border: none;
  background: transparent;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
          align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
          justify-content: center;
  cursor: pointer;
  z-index: 3;
  -webkit-transition: -webkit-transform 0.2s ease;
  transition: -webkit-transform 0.2s ease;
  transition: transform 0.2s ease;
  transition: transform 0.2s ease, -webkit-transform 0.2s ease;
}
.VFpHxQM9:hover {
  -webkit-transform: scale(1.05);
          transform: scale(1.05);
}
.VFpHxQM9:active {
  -webkit-transform: scale(0.95);
          transform: scale(0.95);
}
@media (max-width: 767px) {
  .VFpHxQM9 {
    top: -0.75rem;
    right: -1.125rem;
    width: 3.5rem;
    height: 3.5rem;
  }
}
.op6mmUco {
  width: 100%;
  height: 100%;
  display: block;
  -o-object-fit: contain;
     object-fit: contain;
  pointer-events: none;
}
.cmgEQn6j {
  display: grid;
  grid-template-columns: auto 1fr;
  -webkit-column-gap: 0.5rem;
     -moz-column-gap: 0.5rem;
          column-gap: 0.5rem;
  -webkit-box-align: start;
  -webkit-align-items: start;
          align-items: start;
  text-align: left;
}
.Gb8hbzwG {
  grid-column: 1;
  grid-row: 1;
  align-self: center;
  height: 5.5rem;
  width: auto;
  -o-object-fit: contain;
     object-fit: contain;
  display: block;
  margin-top: -1.5rem;
}
@media (max-width: 767px) {
  .Gb8hbzwG {
    height: 4.2rem;
  }
}
.icSZz1Vf {
  grid-column: 2;
  grid-row: 1;
  align-self: center;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
          align-items: center;
  min-width: 0;
}
.Okv17iUv {
  height: 2.5rem;
  width: auto;
  max-width: 100%;
  -o-object-fit: contain;
     object-fit: contain;
  display: block;
  -webkit-flex-shrink: 0;
          flex-shrink: 0;
}
@media (max-width: 767px) {
  .Okv17iUv {
    height: 1.75rem;
  }
}
.n7q3u9bl {
  grid-column: 2;
  grid-row: 2;
  margin: 0.625rem 0 0.875rem;
  font-size: 1.375rem;
  font-weight: 700;
  color: #3c302a;
  line-height: 1.35;
  letter-spacing: 0.01em;
  width: 100%;
}
@media (max-width: 767px) {
  .n7q3u9bl {
    font-size: 1rem;
    margin-top: 0.5rem;
    margin-bottom: 0.75rem;
  }
}
.ocZdGwOx {
  grid-column: 2;
  grid-row: 3;
  margin: 0;
  font-size: 1rem;
  font-weight: 400;
  color: #5e5447;
  line-height: 1.75;
  max-width: 100%;
  overflow-wrap: break-word;
  word-break: break-word;
  width: 100%;
}
@media (max-width: 767px) {
  .ocZdGwOx {
    font-size: 0.75rem;
    line-height: 1.7;
  }
}
.pLKJetP6 {
  margin: 0;
  font-size: 1rem;
  color: #5e5447;
  line-height: 1.65;
  font-weight: 400;
  white-space: pre-line;
}
@media (max-width: 767px) {
  .pLKJetP6 {
    font-size: 0.875rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/AccountGuideModal/AccountGuideModal.module.less","webpack://./src/styles/mixins.less"],"names":[],"mappings":"AAQA;EACE,eAAA;EACA,QAAA;EACA,+BAAA;EACA,kCAAA;UAAA,0BAAA;EACA,aAAA;ECgDA,oBAAA;EAAA,qBAAA;EAAA,aAAA;EACA,yBAAA;EAAA,2BAAA;UAAA,mBAAA;EACA,wBAAA;EAAA,+BAAA;UAAA,uBAAA;EDhDA,oBAAA;AALF;AAQA;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,mBAAA;EACA,qDAAA;EACA,qCAAA;UAAA,6BAAA;EACA,iBAAA;EACA,+EAAA;AANF;AClBE;EAAA;ID2BE,2BAAA;IACA,sBAAA;EALF;AACF;AAQA;EACE,qCAAA;AANF;AC3BE;EAAA;IDoCE,kCAAA;EALF;AACF;AAQA;EACE,0BAAA;EACA,kBAAA;AANF;ACpCE;EAAA;ID6CE,+BAAA;EALF;AACF;AAQA;EACE;IACE,UAAA;IACA,sCAAA;YAAA,8BAAA;EANF;EAQA;IACE,UAAA;IACA,gCAAA;YAAA,wBAAA;EANF;AACF;AAFA;EACE;IACE,UAAA;IACA,sCAAA;YAAA,8BAAA;EANF;EAQA;IACE,UAAA;IACA,gCAAA;YAAA,wBAAA;EANF;AACF;AAUA;ECwCE,gBAAA;EAEA,SAAA;EAEA,aAAA;EACA,oBAAA;ED3CA,kBAAA;EACA,cAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,YAAA;EACA,uBAAA;EACA,oBAAA;EAAA,qBAAA;EAAA,aAAA;EACA,yBAAA;EAAA,2BAAA;UAAA,mBAAA;EACA,wBAAA;EAAA,+BAAA;UAAA,uBAAA;EACA,eAAA;EACA,UAAA;EACA,+CAAA;EAAA,uCAAA;EAAA,+BAAA;EAAA,4DAAA;AALF;AAOE;EACE,8BAAA;UAAA,sBAAA;AALJ;AAQE;EACE,8BAAA;UAAA,sBAAA;AANJ;AC7EE;EAAA;IDuFE,aAAA;IACA,gBAAA;IACA,aAAA;IACA,cAAA;EANF;AACF;AASA;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,sBAAA;KAAA,mBAAA;EACA,oBAAA;AAPF;AAUA;EACE,aAAA;EACA,+BAAA;EACA,0BAAA;KAAA,uBAAA;UAAA,kBAAA;EACA,wBAAA;EAAA,0BAAA;UAAA,kBAAA;EACA,gBAAA;AARF;AAWA;EACE,cAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;EACA,WAAA;EACA,sBAAA;KAAA,mBAAA;EACA,cAAA;EACA,mBAAA;AATF;AC7GE;EAAA;IDyHE,cAAA;EARF;AACF;AAWA;EACE,cAAA;EACA,WAAA;EACA,kBAAA;EACA,oBAAA;EAAA,qBAAA;EAAA,aAAA;EACA,yBAAA;EAAA,2BAAA;UAAA,mBAAA;EACA,YAAA;AATF;AAYA;EACE,cAAA;EACA,WAAA;EACA,eAAA;EACA,sBAAA;KAAA,mBAAA;EACA,cAAA;EACA,sBAAA;UAAA,cAAA;AAVF;AClIE;EAAA;ID+IE,eAAA;EATF;AACF;AAYA;EACE,cAAA;EACA,WAAA;EACA,2BAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,sBAAA;EACA,WAAA;AAVF;AClJE;EAAA;ID+JE,eAAA;IACA,kBAAA;IACA,sBAAA;EATF;AACF;AAYA;EACE,cAAA;EACA,WAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,eAAA;EACA,yBAAA;EACA,sBAAA;EACA,WAAA;AAVF;ACtKE;EAAA;IDmLE,kBAAA;IACA,gBAAA;EATF;AACF;AAYA;EACE,SAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,qBAAA;AAVF;ACpLE;EAAA;IDiME,mBAAA;EATF;AACF","sourcesContent":["@import '@/styles/variables.less';\n@import '@/styles/mixins.less';\n\n// 与设计稿一致：米色卡片 + 深棕文案（对齐 SupportModal / AlertModal）\n@account-guide-modal-bg: #fffdf2;\n@account-guide-modal-title: #3c302a;\n@account-guide-modal-text: #5e5447;\n\n.overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.55);\n  backdrop-filter: blur(4px);\n  z-index: @z-index-modal + 2;\n  .flex-center();\n  padding: 2.5rem @spacing-md;\n}\n\n.modal {\n  position: relative;\n  width: 100%;\n  max-width: 30rem;\n  box-sizing: border-box;\n  background: @account-guide-modal-bg;\n  border-radius: 2rem;\n  box-shadow: 0 0.625rem 1.75rem rgba(61, 48, 42, 0.22);\n  animation: slideUp 0.3s ease;\n  overflow: visible;\n  font-family: @font-family-sans;\n\n  .mobile({\n    max-width: min(30rem, 92vw);\n    border-radius: 1.75rem;\n  });\n}\n\n.modalDefault {\n  padding: 2.75rem 1.75rem 2rem 1.75rem;\n\n  .mobile({\n    padding: 2.125rem 1.75rem 1.125rem;\n  });\n}\n\n.modalBindGuide {\n  padding: 2.75rem 2rem 2rem;\n  text-align: center;\n\n  .mobile({\n    padding: 2.5rem 1.75rem 1.75rem;\n  });\n}\n\n@keyframes slideUp {\n  from {\n    opacity: 0;\n    transform: translateY(1.25rem);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n// 与 LoginModal 关闭钮一致：橙色圆钮 + 白边 X，半露出卡片右上\n.closeButton {\n  .button-reset();\n  position: absolute;\n  top: -0.875rem;\n  right: -1.5rem;\n  width: 4rem;\n  height: 4rem;\n  padding: 0;\n  border: none;\n  background: transparent;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  z-index: 3;\n  transition: transform 0.2s ease;\n\n  &:hover {\n    transform: scale(1.05);\n  }\n\n  &:active {\n    transform: scale(0.95);\n  }\n\n  .mobile({\n    top: -0.75rem;\n    right: -1.125rem;\n    width: 3.5rem;\n    height: 3.5rem;\n  });\n}\n\n.closeButtonImg {\n  width: 100%;\n  height: 100%;\n  display: block;\n  object-fit: contain;\n  pointer-events: none;\n}\n\n.modalBody {\n  display: grid;\n  grid-template-columns: auto 1fr;\n  column-gap: @spacing-sm;\n  align-items: start;\n  text-align: left;\n}\n\n.logoIcon {\n  grid-column: 1;\n  grid-row: 1;\n  align-self: center;\n  height: 5.5rem;\n  width: auto;\n  object-fit: contain;\n  display: block;\n  margin-top: -1.5rem;\n\n  .mobile({\n    height: 4.2rem;\n  });\n}\n\n.logoTextGroup {\n  grid-column: 2;\n  grid-row: 1;\n  align-self: center;\n  display: flex;\n  align-items: center;\n  min-width: 0;\n}\n\n.logoTextImg {\n  height: 2.5rem;\n  width: auto;\n  max-width: 100%;\n  object-fit: contain;\n  display: block;\n  flex-shrink: 0;\n\n  .mobile({\n    height: 1.75rem;\n  });\n}\n\n.title {\n  grid-column: 2;\n  grid-row: 2;\n  margin: 0.625rem 0 0.875rem;\n  font-size: 1.375rem;\n  font-weight: 700;\n  color: @account-guide-modal-title;\n  line-height: 1.35;\n  letter-spacing: 0.01em;\n  width: 100%;\n\n  .mobile({\n    font-size: @font-size-md;\n    margin-top: 0.5rem;\n    margin-bottom: 0.75rem;\n  });\n}\n\n.content {\n  grid-column: 2;\n  grid-row: 3;\n  margin: 0;\n  font-size: @font-size-md;\n  font-weight: 400;\n  color: @account-guide-modal-text;\n  line-height: 1.75;\n  max-width: 100%;\n  overflow-wrap: break-word;\n  word-break: break-word;\n  width: 100%;\n\n  .mobile({\n    font-size: @font-size-xs;\n    line-height: 1.7;\n  });\n}\n\n.contentBindGuide {\n  margin: 0;\n  font-size: @font-size-md;\n  color: @account-guide-modal-text;\n  line-height: 1.65;\n  font-weight: 400;\n  white-space: pre-line;\n\n  .mobile({\n    font-size: @font-size-sm;\n  });\n}\n","@import './variables.less';\n\n// 响应式 Mixins\n.mobile(@rules) {\n  @media (max-width: 767px) {\n    @rules();\n  }\n}\n\n.mobileNarrow(@rules) {\n  @media (max-width: 413px) {\n    @rules();\n  }\n}\n\n.tablet(@rules) {\n  @media (min-width: 768px) and (max-width: 1023px) {\n    @rules();\n  }\n}\n\n.desktop(@rules) {\n  @media (min-width: 1024px) {\n    @rules();\n  }\n}\n\n.tablet-up(@rules) {\n  @media (min-width: 768px) {\n    @rules();\n  }\n}\n\n// 紧凑 PC（1024~1728 宽）：首页 banner 缩小与垂直微调\n.homeCompactPc(@rules) {\n  @media (min-width: 1024px) and (max-width: 1728px) {\n    @rules();\n  }\n}\n\n.homeCompactPcShort(@rules) {\n  @media (min-width: 1024px) and (max-width: 1728px) and (max-height: 1000px) {\n    @rules();\n  }\n}\n\n// 宽屏 PC（>1728 宽）：首页 banner 放大\n.homeWidePc(@rules) {\n  @media (min-width: 1729px) {\n    @rules();\n  }\n}\n\n// 浏览器放大/缩小时：横向裁切装饰溢出，纵向允许滚动避免内容显示不全\n.zoomScrollablePage() {\n  overflow-x: hidden;\n  overflow-y: auto;\n}\n\n// Flexbox Mixins\n.flex-center() {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.flex-between() {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.flex-start() {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n}\n\n// 文本省略\n.text-ellipsis() {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.text-ellipsis-multi(@lines: 2) {\n  display: -webkit-box;\n  -webkit-line-clamp: @lines;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n// 清除浮动\n.clearfix() {\n  &::after {\n    content: '';\n    display: table;\n    clear: both;\n  }\n}\n\n// 按钮重置\n.button-reset() {\n  border: none;\n  background: none;\n  padding: 0;\n  margin: 0;\n  cursor: pointer;\n  outline: none;\n  font-family: inherit;\n}\n\n// 触摸友好\n.touch-friendly() {\n  min-height: 2.75rem; // 44px\n  min-width: 2.75rem; // 44px\n}\n\n// 可滚动弹窗蒙版：背景 fixed 铺满视口，内容区单独滚动，避免移动端滑出未覆盖区域\n.modalOverlayBackdrop(@bg: rgba(0, 0, 0, 0.55)) {\n  overflow-x: hidden;\n  overflow-y: auto;\n  overscroll-behavior: contain;\n  -webkit-overflow-scrolling: touch;\n\n  &::before {\n    content: '';\n    position: fixed;\n    inset: 0;\n    background: @bg;\n    backdrop-filter: blur(4px);\n    -webkit-backdrop-filter: blur(4px);\n    z-index: -1;\n    pointer-events: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `GAsaC7eW`,
	"modal": `suc4ymdU`,
	"slideUp": `Uu20LBJN`,
	"modalDefault": `zOPoxSzF`,
	"modalBindGuide": `dciSjzjV`,
	"closeButton": `VFpHxQM9`,
	"closeButtonImg": `op6mmUco`,
	"modalBody": `cmgEQn6j`,
	"logoIcon": `Gb8hbzwG`,
	"logoTextGroup": `icSZz1Vf`,
	"logoTextImg": `Okv17iUv`,
	"title": `n7q3u9bl`,
	"content": `ocZdGwOx`,
	"contentBindGuide": `pLKJetP6`
};
export default ___CSS_LOADER_EXPORT___;
